import * as PIXI from 'pixi.js';
import { MenuPopUp } from './menuPopUp';
import { ExitPopUp } from './homePopUp';
import { revealAllSymbols } from './revealAll';
import { soundManager } from './soundManager';
import { languageManager } from './languageManager';
import { handleBuyTickets, handleCoinPlayGame, handleRevealAll } from './networkService';
import { PLAYER_FRONTEND_URL } from '../../../envVariables';
// import { getUser } from '@/network/services/auth.service';
// import { placeBetOnScratchCard } from '@/network/services/poc.service';

export class UIButtonManager {


  constructor(app, sheet, assetLoader) {
    this.app = app;
    this.sheet = sheet;
    this.assetLoader = assetLoader;
    this.buttons = {};
    this.creditsText = null;
    this.betText = null;
    this.maxBetValue = 5; // Example initial max bet, get from game settings
    this.betAmount = 1; // Example initial bet amount, get from game settings
    this.minBetValue = 1; // Example initial min bet, get from game settings
    this.isMaxBet = false;
    this.isMinBet = true;
    this.playClicked = false;
    this.timeText = null;
    this.timeInterval = null;
    this.soundOn = true; // Track sound state
    this.musicOff = false;
    this.userDetail = {}
    this.revealLabelText = null; // Add property for REVEAL label

    if (!this.uiContainer) {
      // Base UI (buttons, timer)
      this.uiContainer = new PIXI.Container();
      this.uiContainer.zIndex = 100;
      this.uiContainer.sortableChildren = true;
      this.app.stage.addChild(this.uiContainer);

      this.popupContainer = new PIXI.Container();
      this.popupContainer.zIndex = 200;
      this.popupContainer.sortableChildren = true;
      this.app.stage.addChild(this.popupContainer);
    }

    // Get the menubtns sheet for the menu popup
    const menuSheet = this.assetLoader.getSheet('menubtns');
    if (!this.uiContainer) {
      this.uiContainer = new PIXI.Container();
      this.app.stage.addChild(this.uiContainer);
    }
  this.menuPopUp = new MenuPopUp(menuSheet, () => this.menuPopUp.hide(), this.assetLoader);
  this.popupContainer.addChild(this.menuPopUp);

  this.exitPopUp = new ExitPopUp(() => {
    window.location.href = PLAYER_FRONTEND_URL;
  }, () => this.exitPopUp.hide());
  this.popupContainer.addChild(this.exitPopUp);
    window.addEventListener('resize', () => {
      this.repositionTimeText();
      if (this.menuPopUp) {
        this.menuPopUp.resize();
      }
      if (this._uiBase) { 
        this.repositionButtons(this._uiBase);
      }
    });
    
    // Listen for language changes
    languageManager.addListener(() => this.updateLanguage());

    this.selectedTicketPrice = 18; // Default selected price
    this.ticketPrices = [18, 9, 4.50, 1.80];
    this.isDropdownOpen = false;
    this.dropdownContainer = new PIXI.Container();
    this.uiContainer.addChild(this.dropdownContainer);
    this.dropdownContainer.visible = false; // Initially hidden

    // Add stage listener to close dropdown
    this.app.stage.interactive = true; // Make sure stage can receive events
    this.app.stage.on('pointertap', () => {
      if (this.isDropdownOpen) {
        this.toggleDropdown();
      }
    });
  }

  setupButtonCursor(button) {
    button.cursor = 'pointer';
    button.on('pointerover', () => {
      this.app.view.style.cursor = 'pointer';
    });
    button.on('pointerout', () => {
      this.app.view.style.cursor = 'default';
    });
  }


  addCornerButtons() {
    // Create a UI container that will be on top of everything
    if (!this.uiContainer) {
      this.uiContainer = new PIXI.Container();
      this.app.stage.addChild(this.uiContainer);
    }

    // Mobile-responsive scaling
    const screenWidth = this.app.screen.width;
    let buttonScale = 0.6;
    let homeBtnX = this.app.screen.width - 200;
    let homeBtnY = 40;
    let menuBtnX = 200;
    let menuBtnY = 40;
    let fullscreenBtnX = 200;
    let fullscreenBtnY = this.app.screen.height - 100;
    
    if (screenWidth <= 480) {
      buttonScale = 0.4;
      // Move to corners for small mobile
      homeBtnX = this.app.screen.width - 40; // Right corner
      homeBtnY = 20;
      menuBtnX = 20; // Left corner
      menuBtnY = 20;
      fullscreenBtnX = 20; // Bottom-left corner
      fullscreenBtnY = this.app.screen.height - 20;
    } else if (screenWidth <= 767) {
      buttonScale = 0.5;
      // Move to corners for regular mobile
      homeBtnX = this.app.screen.width - 80; // Right corner
      homeBtnY = 30;
      menuBtnX = 30; // Left corner
      menuBtnY = 30;
      fullscreenBtnX = 30; // Bottom-left corner
      fullscreenBtnY = this.app.screen.height - 25;
    } else if (screenWidth <= 1024) {
      buttonScale = 0.55;
      // Slightly move towards corners for tablet
      homeBtnX = this.app.screen.width - 120;
      homeBtnY = 35;
      menuBtnX = 50;
      menuBtnY = 35;
      fullscreenBtnX = 180;
      fullscreenBtnY = this.app.screen.height - 95;
    }

    // Home button
    const homeBtn = PIXI.Sprite.from(this.sheet.textures['home_icon_normal_btn.png']);
    homeBtn.anchor.set(1, 0);
    homeBtn.x = homeBtnX;
    homeBtn.y = homeBtnY;
    homeBtn.scale.set(buttonScale);
    homeBtn.interactive = true;
    this.setupButtonCursor(homeBtn);
    homeBtn.on('pointertap', () => {
      if (this.exitPopUp) {
        this.exitPopUp.show();
      } else {
        console.error(
          'Exit popup is not available. This can be caused by a hot-reloading issue. Please try a hard refresh (Ctrl+F5 or Cmd+Shift+R).'
        );
      }
    });
    this.uiContainer.addChild(homeBtn); // Add to UI container instead of stage
    this.buttons.homeBtn = homeBtn;

    // Add time display below home button
    this.addTimeText(homeBtn);

    // Menu button
    const menuBtn = PIXI.Sprite.from(this.sheet.textures['menu_normal_btn.png']);
    menuBtn.anchor.set(0, 0);
    menuBtn.x = menuBtnX;
    menuBtn.y = menuBtnY;
    menuBtn.scale.set(buttonScale);
    menuBtn.interactive = true;
    this.setupButtonCursor(menuBtn);
    menuBtn.on('pointertap', () => {
      this.menuPopUp.show();
    });
    this.uiContainer.addChild(menuBtn); // Add to UI container instead of stage
    this.buttons.menuBtn = menuBtn;

    // Fullscreen button
    const fullscreenBtn = PIXI.Sprite.from(this.sheet.textures['full_screen_icon_btn.png']);
    fullscreenBtn.anchor.set(0, 1);
    fullscreenBtn.x = fullscreenBtnX;
    fullscreenBtn.y = fullscreenBtnY;
    fullscreenBtn.scale.set(buttonScale);
    fullscreenBtn.interactive = true;
    this.setupButtonCursor(fullscreenBtn);
    fullscreenBtn.on('pointertap', () => {
      if (!document.fullscreenElement && !document.webkitFullscreenElement && !document.mozFullScreenElement && !document.msFullscreenElement) {
        // Enter fullscreen
        const view = this.app.view;
        if (view.requestFullscreen) {
          view.requestFullscreen();
        } else if (view.webkitRequestFullscreen) {
          view.webkitRequestFullscreen();
        } else if (view.mozRequestFullScreen) {
          view.mozRequestFullScreen();
        } else if (view.msRequestFullscreen) {
          view.msRequestFullscreen();
        }
      } else {
        // Exit fullscreen
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
      }
    });
    // Listen for fullscreen change to update button texture
    const updateFullscreenBtnTexture = () => {
      if (document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement) {
        fullscreenBtn.texture = this.sheet.textures['minimize_screen_icon_btn.png'];
      } else {
        fullscreenBtn.texture = this.sheet.textures['full_screen_icon_btn.png'];
      }
    };
    document.addEventListener('fullscreenchange', updateFullscreenBtnTexture);
    document.addEventListener('webkitfullscreenchange', updateFullscreenBtnTexture);
    document.addEventListener('mozfullscreenchange', updateFullscreenBtnTexture);
    document.addEventListener('MSFullscreenChange', updateFullscreenBtnTexture);
    this.uiContainer.addChild(fullscreenBtn); // Add to UI container instead of stage
    this.buttons.fullscreenBtn = fullscreenBtn;

    // Ensure UI container is always on top
    this.ensureUIOnTop();
  }


  addTimeText(homeBtn) {
    if (this.timeText) {
      this.app.stage.removeChild(this.timeText);
      clearInterval(this.timeInterval);
    }
    // Create PIXI.Text for time
    const style = new PIXI.TextStyle({
      fontFamily: 'Arial',
      fontSize: 32,
      fill: '#fff',
      fontWeight: 'bold',
      align: 'center',
      stroke: '#000',
      strokeThickness: 2,
      dropShadow: true,
      dropShadowColor: '#000',
      dropShadowBlur: 2,
      dropShadowDistance: 0,
    });
    this.timeText = new PIXI.Text(this.getCurrentTimeString(), style);
    this.timeText.anchor = { x: 0.5, y: 0 };
    this.timeText.zIndex = 100;
    this.app.stage.addChild(this.timeText);
    this.repositionTimeText();
    // Update every second
    this.timeInterval = setInterval(() => {
      this.timeText.text = this.getCurrentTimeString();
      this.repositionTimeText();
    }, 1000);
  }

  getCurrentTimeString() {
    const now = new Date();
    const hours = now.getHours().toString().padStart(2, '0');
    const minutes = now.getMinutes().toString().padStart(2, '0');
    return `${hours}:${minutes}`;
  }

  repositionTimeText() {
    try {
      if (
        // !this.buttons ||
        !this.buttons.homeBtn ||
        !this.timeText ||
        !this.timeText.parent
      ) {
        return;
      }
      
      // Mobile-responsive positioning
      const screenWidth = this.app.screen.width;
      const screenHeight = this.app.screen.height;
      let offsetX = 30;
      let offsetY = 0;
      let fontSize = 32;

    if (screenWidth <= 480) { // Small mobile
      fontSize = 22; // Smaller font size
      this.timeText.anchor.set(1, 1); // Anchor to bottom-right
      this.timeText.x = screenWidth - 15; // 15px from right edge
      this.timeText.y = screenHeight - 15; // 15px from bottom edge
    } else if (screenWidth <= 767) { // Regular mobile
      fontSize = 24; // Smaller font size
      this.timeText.anchor.set(1, 1); // Anchor to bottom-right
      this.timeText.x = screenWidth - 20; // 20px from right edge
      this.timeText.y = screenHeight - 20; // 20px from bottom edge
    } else if (screenWidth <= 1024) { // Tablet
      fontSize = 22;
      this.timeText.anchor.set(0.5, 0); // Revert anchor for tablet/desktop
      const homeBtn = this.buttons.homeBtn; // Use homeBtn for positioning
      offsetX = 25;
      offsetY = 0;
      this.timeText.x = homeBtn.x - offsetX;
      this.timeText.y = homeBtn.y + homeBtn.height + offsetY;
    } else { // Desktop
      fontSize = 32;
      this.timeText.anchor.set(0.5, 0); // Revert anchor for tablet/desktop
      const homeBtn = this.buttons.homeBtn; // Use homeBtn for positioning
      offsetX = 30;
      offsetY = 0;
      this.timeText.x = homeBtn.x - offsetX;
      this.timeText.y = homeBtn.y + homeBtn.height + offsetY;
    }
    
    this.timeText.style.fontSize = fontSize;
    // Position is already set inside the conditions above.
    } catch (error) {
      console.error('Error repositioning time text:', error);
    }
    
  }

  ensureUIOnTop() {
    if (this.app.stage && this.uiContainer && this.popupContainer) {
      this.app.stage.setChildIndex(this.uiContainer, this.app.stage.children.length - 2);
      this.app.stage.setChildIndex(this.popupContainer, this.app.stage.children.length - 1);
    }
  }

  async addUIBaseButtons(uiBase, gameData) {
    // Mobile-responsive scaling
    this._uiBase = uiBase;
    const screenWidth = this.app.screen.width;
    let buttonScale = 0.6;
    let fontSize = 28;
    let smallFontSize = 18;
    let offsetX = 160;
    let offsetY = 16;
    let textOffsetX = 30;
    let textOffsetY = 37;
    let creditsOffsetX = 120;
    let soundOffsetX = 380;
    let infoBtnOffsetX = 100;
    let buyBtnOffsetX = 25;
    let buyBtnOffsetY = -60;
    
    if (screenWidth <= 480) {
      buttonScale = 0.25; // Much smaller for small mobile
      fontSize = 14;
      smallFontSize = 10;
      offsetX = 60;
      offsetY = 8;
      textOffsetX = 25;
      textOffsetY = 10;
      creditsOffsetX = 50;
      soundOffsetX = 150;
      infoBtnOffsetX = 60;
      buyBtnOffsetX = 15;
      buyBtnOffsetY = -40;
    } else if (screenWidth <= 767) {
      buttonScale = 0.35; // Smaller for regular mobile
      fontSize = 18;
      smallFontSize = 12;
      offsetX = 90;
      offsetY = 10;
      textOffsetX = 30;
      textOffsetY = 15;
      creditsOffsetX = 70;
      soundOffsetX = 200;
      infoBtnOffsetX = 80;
      buyBtnOffsetX = 20;
      buyBtnOffsetY = -50;
    } else if (screenWidth <= 1024) {
      buttonScale = 0.4; // Medium for tablet
      fontSize = 24;
      smallFontSize = 16;
      offsetX = 120;
      offsetY = 12;
      textOffsetX = 25;
      textOffsetY = 30;
      creditsOffsetX = 90;
      soundOffsetX = 280;
      infoBtnOffsetX = 90;
      buyBtnOffsetX = 22;
      buyBtnOffsetY = -55;
    }
    
    // Add the green bet value background
    const betValueBg = PIXI.Sprite.from(this.sheet.textures['bet_value_normal_base.png']);
    betValueBg.anchor.set(0, 0.5); // Left center
    betValueBg.x = uiBase.x - uiBase.width / 2 + offsetX;
    betValueBg.y = uiBase.y + uiBase.height / 2 + offsetY;
    betValueBg.scale.set(buttonScale);
    this.uiContainer.addChild(betValueBg);
    this.buttons.betValueBg = betValueBg;

    // Make betValueBg interactive
    betValueBg.interactive = true;
    betValueBg.buttonMode = true;
    this.setupButtonCursor(betValueBg);

    betValueBg.on('pointertap', (event) => {
      event.stopPropagation();
      this.toggleDropdown();
    });

    // Add ticket price text ($10) centered on betValueBg
    const ticketPriceStyle = new PIXI.TextStyle({
      align: 'center',
      dropShadow: true,
      dropShadowAngle: 1.5,
      dropShadowDistance: 2,
      fill: '#fffbe0',
      fontFamily: 'TCCEB',
      fontSize: fontSize,
      fontWeight: 'bolder',
      lineJoin: 'round',
      miterLimit: 0,
      padding: 10,
      stroke: '#3a4124',
      strokeThickness: 3,
      whiteSpace: 'normal',
    });

    const ticketPriceText = new PIXI.Text(`₦${this.selectedTicketPrice.toFixed(2)}`, ticketPriceStyle);
    ticketPriceText.anchor.set(0.5);
    ticketPriceText.x = betValueBg.x + (betValueBg.width * betValueBg.scale.x) / 2 + textOffsetX;
    ticketPriceText.y = betValueBg.y;
    this.uiContainer.addChild(ticketPriceText);
    this.ticketPriceText = ticketPriceText;

    // Make the ticket price text interactive
    ticketPriceText.interactive = true;
    ticketPriceText.buttonMode = true;
    this.setupButtonCursor(ticketPriceText); // Apply custom cursor on hover
    ticketPriceText.on('pointertap', (event) => {
      event.stopPropagation(); // Prevent event from bubbling up to the stage
      this.toggleDropdown();
    });

    // Create dropdown options
    const dropdownTicketPriceStyle = ticketPriceStyle.clone();
    dropdownTicketPriceStyle.fontSize = fontSize * 0.8; // Decrease font size by 20%
    this.createDropdown(betValueBg, dropdownTicketPriceStyle, fontSize, textOffsetX, buttonScale);

    // Add 'TICKET COST' text above betValueBg, using matching icons text style
    const ticketCostTextStyle = {
      align: 'center',
      dropShadow: true,
      dropShadowAngle: 1.5,
      dropShadowDistance: 2,
      fill: '#c3bd94',
      fontFamily: 'TCCEB',
      fontSize: smallFontSize,
      fontWeight: 'bolder',
      lineJoin: 'round',
      miterLimit: 0,
      padding: 20,
      stroke: '#3a4124',
      strokeThickness: 2,
      whiteSpace: 'normal',
    };
    const ticketCostText = new PIXI.Text(languageManager.getText('ticketCost'), ticketCostTextStyle);
    ticketCostText.anchor.set(0.5, 1);
    ticketCostText.x = betValueBg.x + betValueBg.width * betValueBg.scale.x / 2 + textOffsetX; // move right by 30px
    ticketCostText.y = betValueBg.y - textOffsetY; // move up by 20px from previous -10
    this.uiContainer.addChild(ticketCostText);
    this.ticketCostText = ticketCostText;

    // Add 'CREDITS $100' text to the right of 'TICKET COST'
    const creditsTextStyle = {
      align: 'center',
      dropShadow: true,
      dropShadowAngle: 1.5,
      dropShadowDistance: 2,
      fill: '#c3bd94',
      fontFamily: 'TCCEB',
      fontSize: smallFontSize,
      fontWeight: 'bolder',
      lineJoin: 'round',
      miterLimit: 0,
      padding: 20,
      stroke: '#3a4124',
      strokeThickness: 2,
      whiteSpace: 'normal',
    };
    const game = this.app.gameInstance || (window && window.gameInstance);
    const balance = game?.getCredits ? game.getCredits() : 0; 
    const formattedBalance = parseFloat(balance).toFixed(2);
    const creditsText = new PIXI.Text(`₦${languageManager.getText('credits')} ${formattedBalance}`, creditsTextStyle);
    creditsText.anchor.set(0, 1);
    creditsText.x = ticketCostText.x + ticketCostText.width / 2 + creditsOffsetX;
    creditsText.y = ticketCostText.y - 8;
    this.uiContainer.addChild(creditsText);
    this.creditsText = creditsText;

    // Sound button
    const soundBtn = PIXI.Sprite.from(this.sheet.textures['sound_on_normal_btn.png']);
    soundBtn.anchor.set(0.5);
    soundBtn.x = betValueBg.x + betValueBg.width * betValueBg.scale.x + soundOffsetX; // Spaced to the right of betValueBg
    soundBtn.y = uiBase.y + uiBase.height / 2 + 12;
    soundBtn.scale.set(buttonScale);
    soundBtn.interactive = true;
    this.setupButtonCursor(soundBtn);
    soundBtn.on('pointertap', () => {
      this.soundOn = !this.soundOn;
      soundBtn.texture = this.soundOn ? this.sheet.textures['sound_on_normal_btn.png'] : this.sheet.textures['sound_off_normal_btn.png'];
      if (this.soundOn) {
        soundManager.unmute();
      } else {
        soundManager.mute();
      }
      // Sync menu popup sound button if exists
      if (this.menuPopUp && this.menuPopUp.soundsBtn) {
        this.menuPopUp.soundsBtn.texture = soundManager.isMuted()
          ? this.menuPopUp.sheet.textures['ni sounds.png']
          : this.menuPopUp.sheet.textures['sounds.png'];
      }
    });
    this.uiContainer.addChild(soundBtn);
    this.buttons.soundBtn = soundBtn;

    // Info button
    const infoBtn = PIXI.Sprite.from(this.sheet.textures['info_normal_btn.png']);
    infoBtn.anchor.set(0.5);
    infoBtn.x = soundBtn.x + infoBtnOffsetX; // Spaced to the right of soundBtn
    infoBtn.y = uiBase.y + uiBase.height / 2 + 12;
    infoBtn.scale.set(buttonScale);
    infoBtn.interactive = true;
    this.setupButtonCursor(infoBtn);
    infoBtn.on('pointertap', () => {
      if (this.menuPopUp && typeof this.menuPopUp.showInfoPopUp === 'function') {
        this.menuPopUp.showInfoPopUp();
      }
    });
    this.uiContainer.addChild(infoBtn);
    this.buttons.infoBtn = infoBtn;

    // Buy button (right top corner of uiBase)
    // Determine initial button texture based on gameData
    const isContinuationGame = gameData && gameData.scores && gameData.scores.length > 0;
    const initialBuyBtnTexture = isContinuationGame 
                                 ? this.sheet.textures['reveal_all_normal_btn.png'] 
                                 : this.sheet.textures['Buy_normal_btn.png'];                             

    // Buy button (right top corner of uiBase)
    const buyBtn = PIXI.Sprite.from(initialBuyBtnTexture);
    buyBtn.anchor.set(1, 0); // Top right
    // Position at right top corner of uiBase with padding
    buyBtn.x = uiBase.x + uiBase.width / 2 + buyBtnOffsetX; // Adjusted padding from right
    buyBtn.y = uiBase.y + buyBtnOffsetY; // Adjusted padding from top
    buyBtn.scale.set(buttonScale);
    buyBtn.interactive = true;
    buyBtn.buttonMode = true;

    if (screenWidth <= 1023) {
      buyBtn.hitArea = buyBtn.getLocalBounds(); 
    } else {
      buyBtn.hitArea = new PIXI.Rectangle(-buyBtn.width * 1.35, buyBtn.height * 0.2, buyBtn.width, buyBtn.height);
    }
    
    this.setupButtonCursor(buyBtn);
    this.uiContainer.addChild(buyBtn);
    this.buttons.buyBtn = buyBtn;
    // Add play logic: enable symbol revealing when play button is clicked
    //this.playClicked = false;
    buyBtn.on('pointertap', async () => {
      if (!this.playClicked) {
        // Check if enough credits
        // const game = this.app.gameInstance || (window && window.gameInstance);
        let credits = 0;
        if (game && typeof game.getCredits === 'function') {
          credits = game.getCredits();
        } else if (this.app.credits !== undefined) {
          credits = this.app.credits;
        }
        const currentBetAmount = this.selectedTicketPrice; 

        try {
          console.log("Play button clicked. Attempting to buy tickets with betAmount:", currentBetAmount);
          const ticketPurchaseResult = await handleBuyTickets(currentBetAmount); 
          if(ticketPurchaseResult.success) {
            if (game && ticketPurchaseResult.wallet !== undefined && ticketPurchaseResult.wallet !== null) {
              game.setCredits(ticketPurchaseResult.wallet); 
            }
            const gameData = await handleCoinPlayGame(currentBetAmount);
            console.log("Tickets purchased and game played successfully. API Scores:", gameData);
            this.playClicked = true; // Set playClicked to true after successful purchase
          
            // Pass the fetched API scores to symbolManager
            if (this.app.symbolManager && typeof this.app.symbolManager.addActualSymbols === 'function') {
              this.app.symbolManager.addActualSymbols(gameData);
            }
          } else {
            console.error("Ticket purchase failed, not proceeding with coin play game.");
            // Handle failure scenario, e.g., show an error message to the user
            buyBtn.interactive = true; // Re-enable the button on error
            this.playClicked = false; // Reset playClicked state on error
          }

        } catch (error) {
          console.error("Failed to buy tickets on Play button click:", error);
          buyBtn.interactive = true; // Re-enable the button on error
          this.playClicked = false; // Reset playClicked state on error
        }
        if (credits < this.selectedTicketPrice) {
          // Not enough credits, disable play button and show message
          buyBtn.interactive = false;
          buyBtn.alpha = 0.5;
          if (!this.notEnoughCreditsText) {
            const style = new PIXI.TextStyle({
              align: 'center',
              fill: '#ff4444',
              fontFamily: 'TCCEB',
              fontSize: 20,
              fontWeight: 'bolder',
              stroke: '#3a4124',
              strokeThickness: 2,
            });
            this.notEnoughCreditsText = new PIXI.Text(languageManager.getText('notEnoughCredits'), style);
            this.notEnoughCreditsText.anchor.set(0.5);
            this.notEnoughCreditsText.x = buyBtn.x - 450;
            this.notEnoughCreditsText.y = buyBtn.y + buyBtn.height * buyBtn.scale.y + 25;
            this.uiContainer.addChild(this.notEnoughCreditsText);
          } else {
            this.notEnoughCreditsText.visible = true;
          }
          return;
        } else {
          // Deduct $ticket cost from credits
          if (game && typeof game.deductCredits === 'function') {
          } else if (this.app.credits !== undefined) {
            this.app.credits -= this.selectedTicketPrice;
            if (this.setCredits) this.setCredits(this.app.credits);
          }
          if (this.notEnoughCreditsText) {
            this.notEnoughCreditsText.visible = false;
          }
        }
        if (this.app.symbolManager && typeof this.app.symbolManager.enableSymbolRevealing === 'function') {
          this.app.symbolManager.enableSymbolRevealing();
        }
        // Change the button texture to reveal_all_normal_btn.png
        if (this.sheet.textures['reveal_all_normal_btn.png']) {
          buyBtn.texture = this.sheet.textures['reveal_all_normal_btn.png'];
          // Add REVEAL label below the button
          if (!this.revealLabelText) {
            const revealLabelStyle = {
              align: 'center',
              dropShadow: true,
              dropShadowAngle: 1.5,
              dropShadowDistance: 2,
              fill: '#c3bd94',
              fontFamily: 'TCCEB',
              fontSize: 18,
              fontWeight: 'bolder',
              lineJoin: 'round',
              miterLimit: 0,
              padding: 20,
              stroke: '#3a4124',
              strokeThickness: 2,
              whiteSpace: 'normal',
            };

            const screenWidth = this.app.screen.width;
            let revealFontSize = 28;
            if(screenWidth <= 480) {
              revealFontSize = 12;
            } else if(screenWidth <= 767){
              revealFontSize = 14;
            }
            revealLabelStyle.fontSize = revealFontSize;

            const revealLabelText = new PIXI.Text(languageManager.getText('Reveal'), revealLabelStyle);
            revealLabelText.anchor.set(0.5, 0);
            // Position to the right and below the button
            revealLabelText.x = buyBtn.x - buyBtn.width * buyBtn.scale.x / 2 - 20;
            revealLabelText.y = buyBtn.y + buyBtn.height * buyBtn.scale.y + 50;
            this.uiContainer.addChild(revealLabelText);
            this.revealLabelText = revealLabelText;
          } else {
            this.revealLabelText.visible = true;
            // Reposition to the right and below the button
            this.revealLabelText.x = buyBtn.x - buyBtn.width * buyBtn.scale.x / 2 - 20;
            this.revealLabelText.y = buyBtn.y + buyBtn.height * buyBtn.scale.y + 50;
          }
        }
        this.playClicked = true;
        if (!this.musicOff) {
          soundManager.playBgSound();
        }
      } else {
        // On subsequent clicks (Reveal All state), call the reveal-all API
        try {
          console.log("Reveal All button clicked. Calling handleRevealAll API...");
          const revealAllResponse = await handleRevealAll(); // Call the new API function
          console.log("Reveal All API response received (in UIButtonManager):", revealAllResponse);
      
          if (this.app.symbolManager && typeof this.app.symbolManager.revealAllSymbolsFromAPIResponse === 'function') {
              await this.app.symbolManager.revealAllSymbolsFromAPIResponse(revealAllResponse);
          } else {
              console.error("SymbolManager or revealAllSymbolsFromAPIResponse not available on app instance.");
              // Fallback: If for some reason the symbol manager isn't ready, still attempt to trigger win/loss directly
              if (this.app.symbolManager && typeof this.app.symbolManager.checkAndHighlightWin === 'function') {
                  this.app.symbolManager.checkAndHighlightWin(revealAllResponse);
              }
          }
      
          // After all reveals and win/loss logic, disable the reveal all button
          buyBtn.interactive = false;
          buyBtn.alpha = 0.5; // Visually disable
      
        } catch (error) {
          console.error("Failed to reveal all symbols via API:", error);
          // Handle error, e.g., re-enable the button, show an error message
          buyBtn.interactive = true;
          buyBtn.alpha = 1;
        }
      }      
    });
    // Hide REVEAL label initially
    if (this.revealLabelText) {
      this.revealLabelText.visible = false;
    }
    // Link menu music button to global musicOff state
    if (this.menuPopUp && this.menuPopUp.musicBtn) {
      let musicBtn = this.menuPopUp.musicBtn;
      let musicOff = false;
      musicBtn.on('pointertap', () => {
        musicOff = !musicOff;
        this.musicOff = musicOff;
      });
    }
    // Ensure UI is on top after adding all buttons
    this.ensureUIOnTop();
  }

  createDropdown(betValueBg, ticketPriceStyle, fontSize, textOffsetX, buttonScale) {
    this.dropdownContainer.removeChildren(); // Clear existing options if any
    this.ticketPrices.forEach((price, index) => {
      const optionBg = new PIXI.Graphics();
      optionBg.beginFill(0x303732); // Darker green background for options
      optionBg.drawRoundedRect(0, 0, betValueBg.texture.width * 0.9, betValueBg.texture.height, 5);
      optionBg.endFill();
      optionBg.interactive = true;
      optionBg.buttonMode = true;
      this.setupButtonCursor(optionBg);

      const optionText = new PIXI.Text(`₦${price.toFixed(2)}`, ticketPriceStyle);
    
      optionText.interactive = true;
      optionText.buttonMode = true;
      this.setupButtonCursor(optionText);

      const onOptionTap = (event) => { // Define the handler once
        event.stopPropagation();
        console.log('Dropdown option tapped:', price);
        this.selectedTicketPrice = price;
        console.log('New selectedTicketPrice:', this.selectedTicketPrice);
        if (this.ticketPriceText) {
          this.ticketPriceText.text = `₦${this.selectedTicketPrice.toFixed(2)}`;
          console.log('ticketPriceText updated to:', this.ticketPriceText.text);
        } else {
          console.error('ticketPriceText is null or undefined!');
        }
        this.toggleDropdown(); // Hide dropdown after selection
      };

      optionBg.on('pointertap', onOptionTap); // Attach handler to background
      optionText.on('pointertap', onOptionTap);

      this.dropdownContainer.addChild(optionBg);
      this.dropdownContainer.addChild(optionText);
    });
    this.repositionDropdown(betValueBg, buttonScale, fontSize, fontSize * 0.8, this.app.screen.width);
  }

  toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
    this.dropdownContainer.visible = this.isDropdownOpen;
  }

  repositionDropdown(betValueBg, buttonScale, fontSize, smallFontSize, screenWidth) {
    if (!this.dropdownContainer || !betValueBg) {
      return;
    }
  
    let spacingMultiplier = 0.4; // Default for desktop
    let dropdownOffsetYMultiplier = -15; 
    let optionHeightMultiplier = 0.5;

    if (screenWidth <= 480) {
      spacingMultiplier = 0.5;
      dropdownOffsetYMultiplier = -10; 
    } else if (screenWidth <= 767) {
      spacingMultiplier = 1.0;
      dropdownOffsetYMultiplier = -10; 
    } else if (screenWidth <= 1024) {
      spacingMultiplier = 0.5;
      dropdownOffsetYMultiplier = -10;
    }
    
    const spacing = (betValueBg.texture.height * buttonScale) * spacingMultiplier; 
  
    let optionIndex = 0;
    for (let i = 0; i < this.dropdownContainer.children.length; i += 2) {
      const optionBg = this.dropdownContainer.children[i];
      const optionText = this.dropdownContainer.children[i + 1];
  
      if (optionBg instanceof PIXI.Graphics) {
        optionBg.scale.set(buttonScale, buttonScale * optionHeightMultiplier);

        const initialDropdownOffsetY = (betValueBg.height / 2) + (dropdownOffsetYMultiplier * buttonScale); // 10px padding, scaled
        
        if (screenWidth <= 480) {
          optionBg.x = betValueBg.x + 3;
        } else if (screenWidth <= 767) {
          optionBg.x = betValueBg.x + 5;
        } else if (screenWidth <= 1024) {
          optionBg.x = betValueBg.x + 5;
        } else {
          optionBg.x = betValueBg.x + 7;
        }
        optionBg.y = betValueBg.y + initialDropdownOffsetY + (optionIndex * spacing);
      }
  
      if (optionText instanceof PIXI.Text) { 
        optionText.style.fontSize = smallFontSize;
        optionText.anchor.set(0.5); 
        optionText.x = optionBg.x + (optionBg.width / 2);
        optionText.y = optionBg.y + (optionBg.height / 2);
      }
      optionIndex++; 
    }
  }
  

  repositionButtons(uiBase) {
    // Mobile-responsive positioning and scaling
    const screenWidth = this.app.screen.width;
    let homeBtnX = this.app.screen.width - 200;
    let homeBtnY = 40;
    let menuBtnX = 200;
    let menuBtnY = 40;
    let fullscreenBtnX = 200;
    let fullscreenBtnY = this.app.screen.height - 100;
    let buttonScale = 0.6;
    
    if (screenWidth <= 480) {
      // Move to corners for small mobile
      homeBtnX = this.app.screen.width - 20; // Right corner
      homeBtnY = 20;
      menuBtnX = 20; // Left corner
      menuBtnY = 20;
      fullscreenBtnX = 20; // Bottom-left corner
      fullscreenBtnY = this.app.screen.height - 20;
      buttonScale = 0.4;
    } else if (screenWidth <= 767) {
      // Move to corners for regular mobile
      homeBtnX = this.app.screen.width - 20; // Right corner
      homeBtnY = 30;
      menuBtnX = 30; // Left corner
      menuBtnY = 30;
      fullscreenBtnX = 30; // Bottom-left corner
      fullscreenBtnY = this.app.screen.height - 25;
      buttonScale = 0.5;
    } else if (screenWidth <= 1024) {
      // Slightly move towards corners for tablet
      homeBtnX = this.app.screen.width - 20;
      homeBtnY = 35;
      menuBtnX = 20;
      menuBtnY = 35;
      fullscreenBtnX = 20;
      fullscreenBtnY = this.app.screen.height - 35;
      buttonScale = 0.4;
    }
    
    // Corner buttons
    if (this.buttons.homeBtn) {
      this.buttons.homeBtn.scale.set(buttonScale);
      this.buttons.homeBtn.x = homeBtnX;
      this.buttons.homeBtn.y = homeBtnY;
    }
    if (this.buttons.menuBtn) {
      this.buttons.menuBtn.scale.set(buttonScale)
      this.buttons.menuBtn.x = menuBtnX;
      this.buttons.menuBtn.y = menuBtnY;
    }
    if (this.buttons.fullscreenBtn) {
      this.buttons.fullscreenBtn.scale.set(buttonScale);
      this.buttons.fullscreenBtn.x = fullscreenBtnX;
      this.buttons.fullscreenBtn.y = fullscreenBtnY;
    }
    
    // Reposition time text
    if (this.timeText) {
      this.repositionTimeText();
    }
    
    // Reposition UI base buttons if they exist
    if (uiBase && this.buttons.betValueBg) {
      // Mobile-responsive scaling for UI base buttons
      let offsetX = 160;
      let offsetY = 16;
      let textOffsetX = 30;
      let textOffsetY = 37;
      let creditsOffsetX = 120;
      let soundOffsetX = 380;
      let infoBtnOffsetX = 100;
      let buyBtnOffsetX = 25;
      let buyBtnOffsetY = -60;
      let buttonScale = 0.6; 
      let fontSize = 28;
      let smallFontSize = 18;
      
      if (screenWidth <= 480) {
        offsetX = 60;
        offsetY = 8;
        textOffsetX = 30;
        textOffsetY = 10;
        creditsOffsetX = 40;
        soundOffsetX = 170;
        infoBtnOffsetX = 60;
        buyBtnOffsetX = 15;
        buyBtnOffsetY = -40;
        buttonScale = 0.25;
        fontSize = 14;
        smallFontSize = 10;
      } else if (screenWidth <= 767) {
        offsetX = 90;
        offsetY = 10;
        textOffsetX = 30;
        textOffsetY = 15;
        creditsOffsetX = 70;
        soundOffsetX = 220;
        infoBtnOffsetX = 80;
        buyBtnOffsetX = 20;
        buyBtnOffsetY = -50;
        buttonScale = 0.35; // Apply mobile scale
        fontSize = 18;
        smallFontSize = 12;
      } else if (screenWidth <= 1024) {
        offsetX = 120;
        offsetY = 12;
        textOffsetX = 25;
        textOffsetY = 30;
        creditsOffsetX = 90;
        soundOffsetX = 280;
        infoBtnOffsetX = 90;
        buyBtnOffsetX = 22;
        buyBtnOffsetY = -55;
        buttonScale = 0.4; // Apply tablet scale
        fontSize = 24;
        smallFontSize = 16;
      }
      
      this.buttons.betValueBg.x = uiBase.x - uiBase.width / 2 + offsetX;
      this.buttons.betValueBg.y = uiBase.y + uiBase.height / 2 + offsetY;
      this.buttons.betValueBg.scale.set(buttonScale);
      
      if (this.ticketPriceText) {
        //this.ticketPriceText.x = this.buttons.betValueBg.x + (this.buttons.betValueBg.width * this.buttons.betValueBg.scale.x) / 2 + textOffsetX;
        this.ticketPriceText.style.fontSize = fontSize;
        this.ticketPriceText.x = this.buttons.betValueBg.x + (this.buttons.betValueBg.width * this.buttons.betValueBg.scale.x) / 2 + textOffsetX;
        this.ticketPriceText.y = this.buttons.betValueBg.y;
      }
      this.repositionDropdown(this.buttons.betValueBg, buttonScale, fontSize, smallFontSize, screenWidth);
      
      if (this.ticketCostText) {
        this.ticketCostText.style.fontSize = smallFontSize
        this.ticketCostText.x = this.buttons.betValueBg.x + this.buttons.betValueBg.width * this.buttons.betValueBg.scale.x / 2 + textOffsetX;
        this.ticketCostText.y = this.buttons.betValueBg.y - textOffsetY;
      }
      
      if (this.creditsText) {
        this.creditsText.style.fontSize = smallFontSize;
        this.creditsText.x = this.ticketCostText.x + this.ticketCostText.width / 2 + creditsOffsetX;
        this.creditsText.y = this.ticketCostText.y - 8;
      }
      
      if (this.buttons.soundBtn) {
        this.buttons.soundBtn.scale.set(buttonScale);
        this.buttons.soundBtn.x = this.buttons.betValueBg.x + this.buttons.betValueBg.width * this.buttons.betValueBg.scale.x + soundOffsetX;
        this.buttons.soundBtn.y = uiBase.y + uiBase.height / 2 + 5;
      }
      
      if (this.buttons.infoBtn) {
        this.buttons.infoBtn.scale.set(buttonScale);
        this.buttons.infoBtn.x = this.buttons.soundBtn.x + infoBtnOffsetX;
        this.buttons.infoBtn.y = uiBase.y + uiBase.height / 2 + 5;
      }
      
      if (this.buttons.buyBtn) {
        this.buttons.buyBtn.scale.set(buttonScale);
        this.buttons.buyBtn.x = uiBase.x + uiBase.width / 2 + buyBtnOffsetX;
        this.buttons.buyBtn.y = uiBase.y + buyBtnOffsetY;
      }
    }
  }

  repositionTicketCostText() {
   const game = this.app.gameInstance || (window && window.gameInstance);
   if (game && game.uiBase) {
      this.repositionButtons(game.uiBase);
    }
    this.updateLanguage();
  }

  setCredits(amount) {
    if (this.creditsText) {
      this.creditsText.text = ` ${languageManager.getText('credits')} ₦${amount}`;
      this.repositionTicketCostText();
    }
  }

  // Optionally, add a method to hide the REVEAL label if you reset the UI
  hideRevealLabel() {
    if (this.revealLabelText) {
      this.revealLabelText.visible = false;
    }
  }

  showTryAgain() {
    if (this.tryAgainText) return;
    const tryAgainStyle = new PIXI.TextStyle({
      align: 'center',
      dropShadow: true,
      dropShadowAngle: 1.5,
      dropShadowDistance: 2,
      fill: '#ff4444',
      fontFamily: 'TCCEB',
      fontSize: 24,
      fontWeight: 'bolder',
      lineJoin: 'round',
      miterLimit: 0,
      padding: 20,
      stroke: '#3a4124',
      strokeThickness: 2,
      whiteSpace: 'normal',
    });
    this.tryAgainText = new PIXI.Text(languageManager.getText('tryAgain'), tryAgainStyle);
    this.tryAgainText.anchor.set(0.5, 0);
    this.tryAgainText.zIndex = 100;

    let baseX = 100, baseY = 100;
    if (this.creditsText) {
      baseX = this.creditsText.x + this.creditsText.width / 2;
      baseY = this.creditsText.y + this.creditsText.height - 20;
    }

    const screenWidth = this.app.screen.width;
    let leftOffset = 0;
    if (screenWidth <= 767) {
      baseY += 60;
      leftOffset += -30;
    } else if (screenWidth <= 1024) {
      baseY += 0;
    }

    this.tryAgainText.x = baseX + leftOffset;
    this.tryAgainText.y = baseY+10;
    this.uiContainer.addChild(this.tryAgainText);
  }

  hideTryAgain() {
    if (this.tryAgainText) {
      this.uiContainer.removeChild(this.tryAgainText);
      this.tryAgainText = null;
    }
  }

  showWinMessage(amount) {
    if (this.winText || this.winAmountText) return;
    // Style for 'YOU WON!'
    const wonStyle = new PIXI.TextStyle({
      align: 'center',
      dropShadow: true,
      dropShadowAngle: 1.5,
      dropShadowDistance: 2,
      fill: '#c3bd94', // credits color
      fontFamily: 'TCCEB',
      fontSize: 18,
      fontWeight: 'bolder',
      lineJoin: 'round',
      miterLimit: 0,
      padding: 20,
      stroke: '#3a4124',
      strokeThickness: 2,
      whiteSpace: 'normal',
    });
    // Style for amount (match credits $100)
    const amountStyle = new PIXI.TextStyle({
      align: 'center',
      dropShadow: true,
      dropShadowAngle: 1.5,
      dropShadowDistance: 2,
      fill: '#c3bd94', // credits color
      fontFamily: 'TCCEB',
      fontSize: 32,
      fontWeight: 'bolder',
      lineJoin: 'round',
      miterLimit: 0,
      padding: 20,
      stroke: '#3a4124',
      strokeThickness: 2,
      whiteSpace: 'normal',
    });
    this.winText = new PIXI.Text('YOU WON!', wonStyle);
    this.winText.anchor.set(0.5, 0);
    this.winText.zIndex = 100;
    this.winAmountText = new PIXI.Text(amount, amountStyle);
    this.winAmountText.anchor.set(0.5, 0);
    this.winText.zIndex = 100;
    let baseX = 100, baseY = 100;
    if (this.creditsText) {
      baseX = this.creditsText.x + this.creditsText.width / 2;
      baseY = this.creditsText.y + this.creditsText.height - 20;
    }

    const screenWidth = this.app.screen.width;
    let leftOffset = 0;
    if (screenWidth <=767) {
      baseY += 50;
      leftOffset = -30;
    } else if (screenWidth <= 1024) {
      baseY += 0;
    }

    this.winText.x = baseX + leftOffset;
    this.winText.y = baseY;
    this.winAmountText.x = baseX + leftOffset;
    this.winAmountText.y = baseY + this.winText.height + 2;
    this.uiContainer.addChild(this.winText);
    this.uiContainer.addChild(this.winAmountText);
  }

  hideWinMessage() {
    if (this.winText) {
      this.uiContainer.removeChild(this.winText);
      this.winText = null;
    }
    if (this.winAmountText) {
      this.uiContainer.removeChild(this.winAmountText);
      this.winAmountText = null;
    }
  }

  resetGameUI() {
    // Re-enable play button
    if (this.buttons && this.buttons.buyBtn) {
      this.buttons.buyBtn.interactive = true;
      this.buttons.buyBtn.alpha = 1;
      // Reset buy button texture to Buy_normal_btn.png
      if (this.sheet.textures['Buy_normal_btn.png']) {
        this.buttons.buyBtn.texture = this.sheet.textures['Buy_normal_btn.png'];
      }
    }
    // Reset playClicked flag so next click will deduct credits and change texture
    this.playClicked = false;
    // Hide REVEAL label after reset
    if (this.revealLabelText) {
      this.revealLabelText.visible = false;
    }
    this.hideTryAgain();
    this.hideWinMessage();

    if(this.revealLabelText) {
      const screenWidth = this.app.screen.width;
      let revealFontSize = 28;
      if(screenWidth <= 480){
        revealFontSize = 12;
      }else if(screenWidth <= 767) {
        revealFontSize = 14;
      }
      this.revealLabelText.style.fontSize = revealFontSize;

      const buyBtn = this.buttons.buyBtn;
      if (buyBtn) {
        this.revealLabelText.x = buyBtn.x - buyBtn.width * buyBtn.scale.x / 2 - 20;
        this.revealLabelText.y = buyBtn.y + buyBtn.height * buyBtn.scale.y + 50;
      }
    }
    this.ensureUIOnTop();
  }

  /**
   * Sets the UI state for a continuation game (show Reveal All, hide Buy) or a new game (show Buy).
   * @param {boolean} hasPendingBet True if there's an active pending bet (continuation game).
   */
  setGameContinuationUI(hasPendingBet) {
    if (!this.buttons.buyBtn || !this.sheet.textures) {
      console.warn("setGameContinuationUI: Buy button or sheet textures not available.");
      return;
    }

    if (hasPendingBet) {
      // Show Reveal All button, hide Buy button functionality
      this.buttons.buyBtn.texture = this.sheet.textures['reveal_all_normal_btn.png'];
      if (!this.revealLabelText) {
        // Create REVEAL label if it doesn't exist
        const revealLabelStyle = {
          align: 'center',
          dropShadow: true,
          dropShadowAngle: 1.5,
          dropShadowDistance: 2,
          fill: '#c3bd94',
          fontFamily: 'TCCEB',
          fontSize: 18,
          fontWeight: 'bolder',
          lineJoin: 'round',
          miterLimit: 0,
          padding: 20,
          stroke: '#3a4124',
          strokeThickness: 2,
          whiteSpace: 'normal',
        };
        const screenWidth = this.app.screen.width;
        let revealFontSize = 28;
        if (screenWidth <= 480) { revealFontSize = 12; }
        else if (screenWidth <= 767) { revealFontSize = 14; }
        revealLabelStyle.fontSize = revealFontSize;
        this.revealLabelText = new PIXI.Text(languageManager.getText('Reveal'), revealLabelStyle);
        this.revealLabelText.anchor.set(0.5, 0);
        this.uiContainer.addChild(this.revealLabelText);
      }
      this.revealLabelText.x =
        this.buttons.buyBtn.x -
        (this.buttons.buyBtn.width * this.buttons.buyBtn.scale.x) / 2 -
        20;
      this.revealLabelText.y =
        this.buttons.buyBtn.y +
        this.buttons.buyBtn.height * this.buttons.buyBtn.scale.y +
        50;
      this.revealLabelText.visible = true;
      this.playClicked = true; // Indicate that a game is in progress
      this.buttons.buyBtn.interactive = true; // Ensure it's interactive for revealing
      this.buttons.buyBtn.alpha = 1;

      if (this.notEnoughCreditsText) {
        this.notEnoughCreditsText.visible = false;
      }

    } else {
      // Show Buy button, hide Reveal All UI elements
      this.buttons.buyBtn.texture = this.sheet.textures['Buy_normal_btn.png'];
      if (this.revealLabelText) {
        this.revealLabelText.visible = false;
      }
      this.playClicked = false; // Reset for new game
      this.buttons.buyBtn.interactive = true; // Ensure it's interactive for buying
      this.buttons.buyBtn.alpha = 1;
    }

    this.ensureUIOnTop(); // Always ensure UI is on top after changes
  }

  
  updateLanguage() {
    // Update ticket cost text
    if (this.ticketCostText) {
      this.ticketCostText.text = languageManager.getText('ticketCost');
    }
    
    // Update credits text
    if (this.creditsText) {
      const game = this.app.gameInstance || (window && window.gameInstance);
      const balance = game?.getCredits ? game.getCredits() : 0;
      const formattedBalance = parseFloat(balance).toFixed(2);
      this.creditsText.text = ` ${languageManager.getText('credits')} ${formattedBalance}`;
    }

    if (this.winText) {
      this.winText.text = languageManager.getText('youWon');
    }

    if (this.tryAgainText) {
      this.tryAgainText.text = languageManager.getText('tryAgain');
    }
    
    if (this.revealLabelText) {
      this.revealLabelText.text = languageManager.getText('reveal');
    }

    if (this.notEnoughCreditsText) {
      this.notEnoughCreditsText.text = languageManager.getText('notEnoughCredits');
    }
  }
}